import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import {
  GetPractitionerRequest,
  GetPractitionersRequest,
  UpdatePractitionerRequest,
} from "api/types/requests";
import QueryTags from "api/types/QueryTags";
import Practitioner from "api/types/models/practitioner";
import PaginatedResponse from "api/types/PaginatedResponse";

const practitionerEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getPractitioner: builder.query<Practitioner, GetPractitionerRequest>({
    query: ({ practitionerUuid, locationUuid }) => ({
      url: `/practitioners/${practitionerUuid}`,
      params: {
        ...(locationUuid && { location_uuid: locationUuid }),
      },
    }),
    providesTags: ["Practitioner"],
  }),

  getPractitioners: builder.query<
    PaginatedResponse<Practitioner[]>,
    GetPractitionersRequest
  >({
    query: ({ page, size, locationUuid, search }) => ({
      url: "/practitioners",
      params: {
        ...(page && { page }),
        ...(size && { size }),
        ...(search && { search }),
        ...(locationUuid && { location_uuid: locationUuid }),
      },
    }),
    providesTags: ["Practitioners"],
  }),

  updatePractitioner: builder.mutation<Practitioner, UpdatePractitionerRequest>(
    {
      query: ({ practitionerUuid, body }) => ({
        url: `/practitioners/${practitionerUuid}`,
        method: "put",
        body,
      }),
      invalidatesTags: ["Practitioners", "Practitioner"],
    },
  ),
});

export default practitionerEndpoints;
